import {createFileRoute, Navigate} from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_authenticated/_dailymenu/dailymenu/today',
)({
	component: RouteComponent,
})

function RouteComponent() {
	return <Navigate to={"/dailymenu"} />
}
